import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

import {
  ApproveUserCommissionReport,
  UpdateCommissionStatus,
} from "../../Server/api";

function ApproveUserCommReport() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [mobile, setMobile] = useState("");
  const [totalCommission, setTotalCommission] = useState(0);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [tempStartDate, setTempStartDate] = useState("");
const [tempEndDate, setTempEndDate] = useState("");
const [tempMobile, setTempMobile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [reason, setReason] = useState("");
const [filterTrigger, setFilterTrigger] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  
  const getCommissionReport = async () => {
    try {
      const payload = {
        page,
        limit,
        mobile,
        from_date: startDate,
        to_date: endDate,
        search:""
      };
      const res = await ApproveUserCommissionReport(payload);
      setRows(res?.data?.data || []);
      setTotalCommission(res?.data?.total_commission_amount || 0);
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

// useEffect(() => {
//   getCommissionReport();
// }, [page, limit, startDate, endDate, mobile]);

useEffect(() => {
  getCommissionReport();
}, [page, limit, filterTrigger]);

const handleFilter = () => {
  setPage(1);
  setFilterTrigger((prev) => !prev);
};
const handleReset = () => {
  setPage(1);

  setStartDate("");
  setEndDate("");
  setMobile("");

  setFilterTrigger((prev) => !prev);
};
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header bg-color-black">
            <div className="d-flex align-items-center justify-content-between">
              <h3 className="card-title text-white mb-0">
              Approve User Commission List
              </h3>
              <div className="d-flex flex-wrap align-items-center gap-2">
                {/* <button
                  className="backbutton"
                  onClick={() => navigate(-1)}
                >
                  <BsArrowLeft className="me-1" />
                  filter
                </button> */}
                <button
                  className="backbutton"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <BsArrowLeft className="me-1" />
                  {showFilter ? "Close Filter" : "Open Filter"}
                </button>
           

              </div>
            </div>
          </div>

          <div className="card-body">
            {showFilter && (
              <div className="row mb-4">
                <div className="col-md-4">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => {
                      setPage(1);
                      setStartDate(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label>End Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => {
                      setPage(1);
                      setEndDate(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label>Mobile</label>
                  <input
                    type="text"
                    placeholder="Search mobile..."
                    className="form-control"
                    value={mobile}
                    onChange={(e) => {
                      setPage(1);
                      setMobile(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-12 mt-3 d-flex gap-2">

  <button
    className="btn btn-primary"
    onClick={handleFilter}
  >
    Filter
  </button>

  <button
    className="btn btn-secondary"
    onClick={handleReset}
  >
    Reset
  </button>

</div>
              </div>
            )}

            <div className="row">
              <h5 className="mb-0">
                <p>Total Commission: ₹ {totalCommission.toFixed(2)}</p>
              </h5>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                
                    <th>DATE</th>
                    <th>MOBILE</th>
                
                             <th>Commission Percentage</th>
                    <th>Commission Amount</th>
                    <th>STATUS</th>
                    <th>REMARK</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 ? (
                    <tr>
                      <td
                        colSpan="6"
                        className="py-5"
                      >
                        <strong>No Data</strong>
                      </td>
                    </tr>
                  ) : (
                    rows.map((r, i) => (
                      <tr key={i}>
                    
                        <td>
                          {new Date(
                            r?.createdAt
                          ).toLocaleDateString()}
                        </td>
                        <td>{r?.mobile}</td>
                       
                        <td>
                          {r?.commission_percent}
                        </td>
                        <td>
                          {r?.commission_amount}
                        </td>
                          <td>
                          <span
                            className="text-success"
                                 > {r?.status}
                          </span>
                        </td>
                        <td>{r?.remark}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div>
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(
                      Number(e.target.value)
                    );
                    setPage(1);
                  }}
                  className="form-select w-auto"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                </select>
              </div>
              <div className="paginationall">
                <button
                  disabled={page === 1}
                  onClick={() =>
                    setPage((p) => p - 1)
                  }
                  className="pagination_button"
                >
                  <MdOutlineKeyboardArrowLeft />
                </button>
                <button
                  disabled={rows.length < limit}
                  onClick={() =>
                    setPage((p) => p + 1)
                  }
                  className="pagination_button"
                >
                  <MdOutlineKeyboardArrowRight />
                </button>

              </div>
            </div>

          </div>
        </div>
      </div>
    
    </div>
  );
}

export default ApproveUserCommReport;